import React from 'react';
import './recomendaciones.css';

const Recomendaciones = () => {

  return (

    <section className="recomendaciones" id="recomendaciones">
        
      <div className="rectangulo"></div>

      <div className="contenido-seccion">

        <h2>Te Recomendamos</h2>

        <div className="galeria">

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion54.jpeg"></img>

            <div className="overlay">
              <h3>La Morsa Food</h3>
              <a href="https://www.facebook.com/MartvProd/videos/629920809037967/">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion53.jpeg"></img>

            <div className="overlay">
              <h3>Estampados y Personalizados</h3>
              <a href="https://www.facebook.com/100066718834054/posts/pfbid02gvQyi3EC3p8dWo2UwBnuGtVpatu7MoeH4WjBepFwcWCd4UyuLeYhkf75K3M1Ziecl/?mibextid=DcJ9fc">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion52.jpeg"></img>

            <div className="overlay">
              <h3>La Martina</h3>
              <a href="https://www.facebook.com/LaMartinaPradera/videos/811122776729458/">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion51.jpeg"></img>

            <div className="overlay">
              <h3>Fundación educativa el triunfo</h3>
              <a href="https://www.facebook.com/100066718834054/posts/pfbid0SggFntaQ5cFqbkRvpa2tnG1Bvsv6huUhnvbzcMQEKjyPTVDvWDrSzsdE2rmJ3izGl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion50.jpeg"></img>

            <div className="overlay">
              <h3>La Sazón de Martha</h3>
              <a href="https://www.facebook.com/100066718834054/posts/pfbid02y9NJWzPH3UAod3SVSw6bJt7JzNWnZyskhpYxAA2NM2MLDN1tadvkiMgttrUuMWzyl/?mibextid=DcJ9fc">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion49.jpeg"></img>

            <div className="overlay">
              <h3>MecarPava</h3>
              <a href="https://www.facebook.com/100066718834054/posts/pfbid022njJ8C76hn3VGRToGY1AsXoY426wGzvHPBHhjxJVbP67Lo2azZTekvNZizPYsGtl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion48.jpeg"></img>

            <div className="overlay">
              <h3>El Punto del Hogar</h3>
              <a href="https://www.facebook.com/MartvProd/videos/767644541491775/">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/hotel.jpeg"></img>

            <div className="overlay">
              <h3>Motel Amsterdam</h3>
              <a href="https://www.facebook.com/MartvProd/videos/564695992018713">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion7.jpeg"></img>

            <div className="overlay">
              <h3>El Boton de Oro</h3>
              <a href="https://www.facebook.com/MartvProd/videos/239534611955791">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion47.jpeg"></img>

            <div className="overlay">
              <h3>Oferta en Licores RJ</h3>
              <a href="https://www.facebook.com/reel/272107138602769/?s=single_unit">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion46.jpeg"></img>

            <div className="overlay">
              <h3>Las Palmeras</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid02ati5B6pQsFbvZorwDrJbAQ8HfjgthKg5KFaaZfLFDist61EmgAdkNpcsRt3Sdtnhl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion45.jpeg"></img>

            <div className="overlay">
              <h3>Evelin en Pradera Valle</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid0PH6twW9mxN9jZrtiS7zq1vfjcitVonhgwNDwGEHi7rfAUpqUYr1aKZCqLb7JUCAal/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion44.jpeg"></img>

            <div className="overlay">
              <h3>SIERACOFFEE</h3>
              <a href="https://www.facebook.com/100066718834054/posts/pfbid02xj87XzqJwpwG3gQ9SE17u9JNsudm1vBUKhQ9L9RWMzkVD7nLc5faZnvngi9y7i4yl/?mibextid=DcJ9fc">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion43.jpeg"></img>

            <div className="overlay">
              <h3>Lili Pink</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid02S6hSusr1Df61Hn1jDdViGFR816fxU2RLHVPBVPkaAhFjoYgKRWZsck8cqGUP7WNKl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion42.jpeg"></img>

            <div className="overlay">
              <h3>Mundo Natural IBASA</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid0w8Vy2bcGQwA3fEB1mRdq5LETjSYttzDQv7SKX1Ucu7HtWmySwU8ogqGcjtD2g4pxl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion41.jpeg"></img>

            <div className="overlay">
              <h3>The HALO Trust</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid02zSP3iE92HgdwQcCLLDu91qVNJuoydc8DAooBZ1UirksVs391ajHvRVg41iPbHcQAl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion40.jpeg"></img>

            <div className="overlay">
              <h3>ASADOS DE PRADO'S</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid02bjR6UFno5VSJkywNLX7RCjpjCpxFaLJDbA1ZHis7otPQhSeio5KvqimExg8sy1Nfl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion39.jpeg"></img>

            <div className="overlay">
              <h3>Colsultorio Veterinario Perla</h3>
              <a href="https://www.facebook.com/MartvProd/videos/754386849420127/">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion38.jpeg"></img>

            <div className="overlay">
              <h3>Jornadas Recreativas Sieraook</h3>
              <a href="https://www.facebook.com/100066718834054/posts/pfbid035dhtE9ZYN7kK64rUkEfjVTHvfykcyPxFkx4PcsaASE3nYWNuugb1WSPev9pXEWt8l/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion37.jpeg"></img>

            <div className="overlay">
              <h3>Festival de las Carnes</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid06XMHJvt3UpsrNM6EmxhjG7iC9i5guYxWrQJRa7KTUKWDF9YRbAWGBvg2qmKjQfVrl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion36.jpeg"></img>

            <div className="overlay">
              <h3>El Fogonazo</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid0Usjw4xWozxjXbPL4twzNsBuJ7W6ywujeoFMJtAtopQhSQKXh9vxTvqMkSeqfdRtxl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion35.jpeg"></img>

            <div className="overlay">
              <h3>Especial Cuaresma!</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid02skyEpkuh3RLMJGVGHjHEhVdWUKqwBYW4TFQLtXAcfiQKQNgLVAivSQ7GdyhRcEnCl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion16.jpeg"></img>

            <div className="overlay">
              <h3>RioPaila</h3>
              <a href="https://www.facebook.com/watch/?v=934623754201026&extid=CL-UNK-UNK-UNK-IOS_GK0T-GK1C&mibextid=2Rb1fB&ref=sharing">Mas información</a>
            </div>

          </div>


          <div className="proyecto">

            <img className="p1" src="./img/recomendacion34.jpeg"></img>

            <div className="overlay">
              <h3>Licores RJ</h3>
              <a href="https://www.facebook.com/MartvProd/videos/989409745355899">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion33.jpeg"></img>

            <div className="overlay">
              <h3>Momentos de Gratitud</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid0Py2VBVATBeZX4da3pePdsjHoZAVQXF8QeLrpo1MCb6ZdeJKtaWsG7uC7nN1BYmagl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion30.jpeg"></img>

            <div className="overlay">
              <h3>Festival de la Familia</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid0Rnjq8FugoqTbMrXAZ9GFj3tQ4y7mhfGnn1q84TiU7J1dFqMqxvTLVbDZGeY7wWAtl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion29.jpeg"></img>

            <div className="overlay">
              <h3>CÁRNICOS MINARO</h3>
              <a href="https://www.facebook.com/watch/?v=570961654931376&extid=CL-UNK-UNK-UNK-IOS_GK0T-GK1C&mibextid=2Rb1fB&ref=sharing">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion28.jpeg"></img>

            <div className="overlay">
              <h3>Crecer Centro Médico Especializado en Pradera</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid02BBeMiYbBbvLyUhNNBRni8a8iK1rTaCAUWLMM4WRD6sCsyK64MGbz1ovpQgF6EpnLl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion32.jpeg"></img>

            <div className="overlay">
              <h3>Inversiones ISA</h3>
              <a href="https://www.facebook.com/isabella.guitierrez.16/videos/1476792642851830/">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion24.jpeg"></img>

            <div className="overlay">
              <h3>Droguería Más si Más</h3>
              <a href="https://www.facebook.com/MartvProd/videos/532331875442507">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion22.jpeg"></img>

            <div className="overlay">
              <h3>Promociones en Mix Carnes</h3>
              <a href="https://www.facebook.com/watch/?v=737664144628585&extid=CL-UNK-UNK-UNK-IOS_GK0T-GK1C&mibextid=2Rb1fB&ref=sharing">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion21.jpeg"></img>

            <div className="overlay">
              <h3>Parcelación Campestre Mirador las Veraneras</h3>
              <a href="https://www.facebook.com/100066718834054/posts/pfbid02B4fnaLPvtvUAFbwMbXDk7d8WzVrN1bxAR5UfiRyPor49grMjvsLyGM4qVWa8j1o1l/?mibextid=DcJ9fc">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion18.jpeg"></img>

            <div className="overlay">
              <h3>Complejo deportivo SportCenter Ámsterdan</h3>
              <a href="https://www.facebook.com/watch/?v=892083058699024&extid=CL-UNK-UNK-UNK-IOS_GK0T-GK1C&mibextid=2Rb1fB&ref=sharing">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion15.jpeg"></img>

            <div className="overlay">
              <h3>MercaPava Mayorista</h3>
              <a href="https://www.facebook.com/100064842964065/posts/pfbid0aMeH9TPqXg5hgpbWnVZvUiqJaiMxSGRRX1NTkqX7UrV2tWT6bHPHfdJJJkKp5eial/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion13.jpeg"></img>

            <div className="overlay">
              <h3>Medicina Estetica y Regeneración</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid04sBjXLJWmv66QYdMJuMkdCA2AwpgGxfkzjmY1A6EpptUJA6AphAEDpQXnXSGL1t8l/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/liceo.jpeg"></img>

            <div className="overlay">
              <h3>Liceo Gotitas Pradera</h3>
              <a href="https://www.facebook.com/100067924022358/posts/pfbid02AYLrxUtsmibhWGZrUCFZ54Crm2fKkoyC2h2ro1jEW3VtthxNWaPozL98LvpEnFtAl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion9.jpeg"></img>

            <div className="overlay">
              <h3>Voluntarios Mayagüez 2022</h3>
              <a href="https://www.facebook.com/watch/?extid=CL-UNK-UNK-UNK-IOS_GK0T-GK1C&mibextid=2Rb1fB&v=604682544804108">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion11.jpeg"></img>

            <div className="overlay">
              <h3>El Barril de la 6°</h3>
              <a href="https://www.facebook.com/MartvProd/videos/1149882249300719">Mas información</a>
            </div>

          </div>

          <div className="proyecto">

            <img className="p1" src="./img/recomendacion12.jpeg"></img>

            <div className="overlay">
              <h3>#NO ESTAS SOLO</h3>
              <a href="https://www.facebook.com/1719997704942461/posts/pfbid028y9iaK8fDyD5qJh4mCqyQtES1CCxHujMxvJuC4c25XsaBA1LzEo4z86tTxE3zuZfl/?mibextid=cr9u03">Mas información</a>
            </div>

          </div>

        </div>

      </div>

    </section>

  );

};

export default Recomendaciones;